import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mainAbout" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = { class: "left" }
const _hoisted_5 = { class: "getLinkWrapper" }
const _hoisted_6 = { class: "getLinkBlock animatedBlock" }
const _hoisted_7 = { class: "field nameBlock" }
const _hoisted_8 = { class: "param" }
const _hoisted_9 = { class: "data name animated" }
const _hoisted_10 = { class: "field priceBlock animated" }
const _hoisted_11 = { class: "param" }
const _hoisted_12 = { class: "data price animated" }
const _hoisted_13 = { class: "btnIconType2 animated" }
const _hoisted_14 = { class: "text animated" }
const _hoisted_15 = { class: "animated" }
const _hoisted_16 = { class: "animated" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "animated" }, "/", -1)
const _hoisted_18 = { class: "animated" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "icon-arrow" }, null, -1)
const _hoisted_20 = { class: "right" }
const _hoisted_21 = { class: "titleContainer" }
const _hoisted_22 = {
  class: "sectionTitle lg font-prompt",
  style: {"font-size":"38px"}
}
const _hoisted_23 = { class: "contentContainer" }
const _hoisted_24 = { class: "textBlock" }
const _hoisted_25 = { style: {"font-size":"18px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("span", _hoisted_8, _toDisplayString(_ctx.t("mainAbout.left.productNameLabel")), 1),
                _createVNode("span", _hoisted_9, _toDisplayString(_ctx.t("mainAbout.left.productNameLabel")), 1)
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode("span", _hoisted_11, _toDisplayString(_ctx.t("mainAbout.left.priceLabel")), 1),
                _createVNode("span", _hoisted_12, _toDisplayString(_ctx.t("mainAbout.left.priceValue")), 1)
              ]),
              _createVNode("div", _hoisted_13, [
                _createVNode("span", _hoisted_14, [
                  _createVNode("span", _hoisted_15, _toDisplayString(_ctx.t("mainAbout.left.payLabel1")), 1),
                  _createVNode("span", _hoisted_16, _toDisplayString(_ctx.t("mainAbout.left.payLabel2")), 1),
                  _hoisted_17,
                  _createVNode("span", _hoisted_18, _toDisplayString(_ctx.t("mainAbout.left.payValue")), 1)
                ]),
                _hoisted_19
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_20, [
          _createVNode("div", _hoisted_21, [
            _createVNode("span", _hoisted_22, _toDisplayString(_ctx.t("mainAbout.right.title1")), 1)
          ]),
          _createVNode("div", _hoisted_23, [
            _createVNode("div", _hoisted_24, [
              _createVNode("p", _hoisted_25, _toDisplayString(_ctx.t("mainAbout.right.content")), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}